import { User } from 'interfaces/user'
import { Dispatch } from 'redux'
import { UserActionType } from "../action-types/userTypes"
import { Action } from '../actions/userActions'
import { PaginatedModel } from 'interfaces/pagination'

// export const listUsers = (user: PaginatedModel<User>) => {
//     return (dispatch: Dispatch<Action>) => {
//         dispatch({
//             type: UserActionType.PAGINATE,
//             payload: user
//         })
//     }
// }

export const paginateUsers = (data: PaginatedModel<User>) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: UserActionType.PAGINATE_USERS,
            payload: data
        })
    }
}

export const createUser = (user: User) => {
    console.log(user);
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: UserActionType.CREATE_USER,
            payload: user
        })
    }
}

export const updateUser = (user: User) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: UserActionType.UPDATE_USER,
            payload: user
        })
    }
}

export const deleteUser = (userId: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: UserActionType.DELETE_USER,
            payload: userId
        })
    }
}